import {
  DEPRECATED_backwardsCompatibleValues,
  useStrictLocalization,
} from "@faire/web--source/common/localization";
import { getCountryDisplayNameFromSessionCountry } from "@faire/web--source/common/localization/getCountryDisplayNameFromSessionCountry";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import getPopularSearches from "@faire/web-api--source/api/seo/popular-searches/get";
import React from "react";

import {
  MostPopularSearches,
  NUM_OF_SEARCH_PILLS_TO_FETCH,
} from "@faire/retailer/components/MostPopularSearches/MostPopularSearches";
import { discoverSearch } from "@faire/retailer/lib/seoPaths";
import { getSessionCountry } from "@faire/retailer/serialized-data/getSessionCountry";

export const TrendingOnFaire: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const title = (
    <StrictLocalMsg
      defaultMessage="Trending on Faire"
      description={{
        text: "Search terms currently popular on the marketplace",
      }}
    />
  );

  const subtitle = (
    <StrictLocalMsg defaultMessage="Popular wholesale product ideas on the marketplace." />
  );

  const promise = getPopularSearches({
    max_results: NUM_OF_SEARCH_PILLS_TO_FETCH,
  });

  const countryDisplayName = getCountryDisplayNameFromSessionCountry(
    getSessionCountry(),
    strictLocalize
  );
  const helmetData = {
    title: countryDisplayName
      ? strictLocalize(
          {
            defaultMessage:
              "Faire {country} - Shop trending products for your store in Faire's B2B marketplace",
            description: {
              text: "Title for trending on Faire page with country tag.",
            },
          },
          DEPRECATED_backwardsCompatibleValues({ country: countryDisplayName })
        )
      : strictLocalize({
          defaultMessage:
            "Faire - Shop trending products for your store in Faire's B2B marketplace",
          description: { text: "Title for trending on Faire page." },
        }),
    description: strictLocalize({
      defaultMessage:
        "Shop most popular wholesale products for your store. Stock up on brands they'll love, with free returns and net 60 terms.",
    }),
  };

  return (
    <MostPopularSearches
      title={title}
      subtitle={subtitle}
      clickEventPrefix="/click/popular-searches-page"
      promise={promise}
      helmetData={helmetData}
      linkTo={discoverSearch}
    />
  );
};
